// Module
var code = `<div class="placeholder__wrap">
	<span class="placeholder__icon"></span>
	<span class="placeholder__name" rv-text="content.text"></span>
</div>`;
// Exports
export default code;